module.exports = __webpack_public_path__ + "img/xxxx.ce276de0.jpg";